import { GetCheckerPartnerDetails } from "../../Api/GetCheckerDetailsAPI"

// service to handle get pdf report api
const GetPartnerCheckerDetailsService = async(
    id: string, // scan id
) => {
    const response = await GetCheckerPartnerDetails(id)
    if (response) {
       return response?.Data
    }
}

export { GetPartnerCheckerDetailsService }